import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AppBar, Toolbar, Typography, IconButton, Button } from "@mui/material";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";

export default function Navbar({ title, onGoBack, onSave }) {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ top: 0, zIndex: 1100, backgroundColor: "#1565C0", minHeight: 52 }}
    >
      <Toolbar sx={{ minHeight: "52px !important" }}>
        <Button
          onClick={onGoBack}
          startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
          sx={{
            color: "#fff",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 14,
            borderRadius: "20px",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" },
          }}
        >
          Exit
        </Button>

        <Typography
          sx={{
            flexGrow: 1,
            fontWeight: 600,
            fontSize: 17,
            pl: 2,
          }}
        >
          {title}
        </Typography>

        <Button
          onClick={onSave}
          variant="contained"
          startIcon={<SaveRoundedIcon sx={{ fontSize: 16 }} />}
          sx={{
            backgroundColor: "rgba(255,255,255,0.15)",
            color: "#fff",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,
            borderRadius: "20px",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.25)",
              boxShadow: "none",
            },
          }}
        >
          Save
        </Button>
      </Toolbar>
    </AppBar>
  );
}
